<template>
  <modal-provider
    name="out-of-stock-modal"
    :width="600"
    classList="out-of-stock-modal"
    :title="$t('product.out_of_stock.title')"
  >
    <p class="out-of-stock-modal__description">
      {{ $t('product.out_of_stock.description') }}
    </p>

    <ProductRecommendations
      class="out-of-stock-modal__rendered-blocks"
      :title="recomendedProducts.title"
      :products="recomendedProducts.data"
    />
  </modal-provider>
</template>

<script>
import ProductRecommendations from '@/components/product/product-page/ProductRecommendations'

export default {
  name: 'OutOfStockModal',
  components: {
    ProductRecommendations
  },
  props: {
    recomendedProducts: {
      type: Object,
      default: () => ({
        title: '',
        data: []
      })
    }
  }
}
</script>

<style scoped lang="sass">
.out-of-stock-modal
  &__description
    all: unset
    display: block
    font-size: 14px
    line-height: 21px
    letter-spacing: 0
    color: $text-color

    margin-inline: 20px

  &__rendered-blocks
    margin-top: 10px

    +mmin($tablet)
      margin-top: 15px

::v-deep
  .modal__title
    padding-bottom: 10px

  .modal-body
    padding: 0
    scrollbar-gutter: auto

  .modal-heading
    padding: 20px 20px 0
</style>
